import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

export interface IFeedbackMessage {
  type: 'error' | 'info' | 'success';
  message: TTextLocalized;
}

export interface IFeedbackMessageOptions {
  className?: string;
  /**
   * The duration in seconds over which the feedback message is displayed before
   * it times out and gets hidden and defaults to 3 seconds.
   */
  feedback: IFeedbackMessage;
}

interface IFeedbackMessageProps extends IFeedbackMessageOptions {
  // Add more feedback message props here
}

/**
 * -----------------------------------------------------------------------------
 * Displays a floating or inline feedback message and formats it depending on
 * the type.
 */
export function FeedbackMessage({
  className = '',
  feedback,
}: IFeedbackMessageProps) {
  const { message, type } = feedback;

  let feedbackTypeClass = '';

  if (type === 'error') {
    feedbackTypeClass = 'text-red-800 border-red-200/80 bg-red-100/50';
  } else if (type === 'info' || type === 'success') {
    feedbackTypeClass = 'text-green-800 border-green-200/80 bg-green-100/50';
  }

  return (
    <div
      className={`
        pointer-events-none mb-4 inline-flex h-auto w-auto max-w-xs items-center
        justify-center rounded-3xl border bg-white p-2 px-4 text-center text-sm
        transition-all  duration-300
        ${className} ${feedbackTypeClass}
      `}
    >
      <Text text={message} />
    </div>
  );
}
